import api from "../../common/dependencies/utils/Api";
import {
 
  FAQ_PAGE_DATA,
} from "../../common/constants/ApplicationUrl";

export const GetFaqServices = {
 


  getFaqDataList() {
    return api
      .GET(`${FAQ_PAGE_DATA}`)
      .then((response) => {
        const { data: { responseCode, data } = {} } = response;
        if (responseCode === 200) {
          return data;
        } else {
          return Promise.reject(response.data);
        }
      })
      .catch((e) => {
        return Promise.reject(e);
      });
  },
};
